import { render, staticRenderFns } from "./AccordionTabs.vue?vue&type=template&id=5dd1429f&scoped=true"
import script from "./AccordionTabs.vue?vue&type=script&lang=js"
export * from "./AccordionTabs.vue?vue&type=script&lang=js"
import style0 from "./AccordionTabs.vue?vue&type=style&index=0&id=5dd1429f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd1429f",
  null
  
)

export default component.exports